import { Routes } from '@/api/Routes';
import { http } from '@/common/utils/HttpServices';
import { EmailSuivi, SuiviDI } from '@/modules/OptionsSuiviInterventions/store/state';
import { AxiosResponse } from 'axios';

class OptionsSuiviInterventionService {

    public getSuiviDI(): Promise<AxiosResponse<SuiviDI>> {
        return http.get<SuiviDI>(Routes.SuiviDIRoutes.GetSuiviDI());
    }

    public activerSuiviDI(): Promise<AxiosResponse<SuiviDI>> {
        return http.put(Routes.SuiviDIRoutes.ActivationSuiviDI());
    }

    public desactiverSuiviDI(): Promise<AxiosResponse<SuiviDI>> {
        return http.delete(Routes.SuiviDIRoutes.ActivationSuiviDI());
    }

    public activerEmailSuivi(emailId: number): Promise<AxiosResponse<EmailSuivi>> {
        return http.put(Routes.SuiviDIRoutes.ActivationEmailSuiviDI(emailId));
    }

    public desactiverEmailSuivi(emailId: number): Promise<AxiosResponse<EmailSuivi>> {
        return http.delete(Routes.SuiviDIRoutes.ActivationEmailSuiviDI(emailId));
    }

    public supprimerEmailSuivi(emailId: number): Promise<AxiosResponse> {
        return http.delete(Routes.SuiviDIRoutes.SuppressionEmailSuiviDI(emailId));
    }

    public ajouterEmailSuivi(email: string): Promise<AxiosResponse<EmailSuivi>> {
        return http.post(Routes.SuiviDIRoutes.AjouterEmailSuiviDI(), {email: email});
    }

}

export default new OptionsSuiviInterventionService();
